import { render, staticRenderFns } from "./TransferPlacesAddView.vue?vue&type=template&id=43a2a54c&"
import script from "./TransferPlacesAddView.vue?vue&type=script&lang=js&"
export * from "./TransferPlacesAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports